module.exports = __webpack_public_path__ + "img/close.c8884489.svg";